import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from 'src/app/appointment/appointment.service';
import { NewCaseComponent } from '../new-case/new-case.component';

@Component({
  selector: 'app-client-list-popup',
  templateUrl: './client-list-popup.component.html',
  styleUrls: ['./client-list-popup.component.css']
})
export class ClientListPopupComponent implements OnInit {
  patients: any[] = [];
  selected_patient_id: number;
  searchText;
  modalOption: NgbModalOptions = {};

  constructor(public activeModal: NgbActiveModal,
    private appointmentService: AppointmentService
    , private modalService: NgbModal) { }

  ngOnInit() {
    this.loadPatients();

  }
  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  loadPatients() {
    this.appointmentService.getPatientslookup().subscribe((patients: any) => {
      this.patients = patients;
    });
  }

  CardClick(data) {
    const index = this.patients.indexOf(data);

    // for single selection
    this.patients.forEach(ele => {
      ele.isHighlight = true;
    });
    // Card select or not(color change)
    this.patients[index].isHighlight = !this.patients[index].isHighlight;
    this.selected_patient_id = data.patientId;

  }


  clientSelect() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    this.modalOption.windowClass = 'invitestyle';
    this.activeModal.close('Modal Closed');
    const dialogRef = this.modalService.open(NewCaseComponent, this.modalOption);
    dialogRef.componentInstance.data = { participantId: this.selected_patient_id };

    dialogRef.result.then((result) => {

    });

  }
}
